const limits = {
  maxLeaveRequestFileUploadSize: 1 * 1024 * 1024 * 1024, // 1GB
  minMedicalReimbursementAmount: 0,
  fetchDataCount: {
    xs: 50,
    sm: 100,
    md: 250,
    lg: 500,
    xl: 1000,
  },
}

export default limits
